import videojs from 'video.js';
import utils from './utils.js';
const Component = videojs.getComponent('Component');

const dom = videojs.dom || videojs;

const DEFAULTS = {
  caption: 'New feedback',
  issues: [
    'Select feedback theme',
    'Video problems',
    'Sound problems',
    'Log in/sign up problems',
    'Other problems'
  ],
  skipDefaultIssues: false,
  subText: '',
  data: {},
  util_data: {
    referrer: utils.isIFrame() ? document.referrer : document.location.href
  },
  formScope: 'feedback',
  url: '/',
  helpUrl: ''
};

/**
 * The button component for showing feedback form
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends Component
 */
class FeedbackForm extends Component {
  constructor(player, options) {
    options.issues = options.issues || []; 

    let options_ = Object.assign({}, DEFAULTS, options);

    if (options.skipDefaultIssues) {
      options_.issues = options.issues.slice();
    } else { // insert issues before 'Others'
      options_.issues = DEFAULTS.issues.slice();
      options_.issues.splice(-1, 0, ...options.issues);
    }

    super(player, options_);
    this.playerPaused = true;
    this.hide();
    this.setListeners_();
  }

  showHelpInstruction() {
    return !!this.options_.helpUrl;
  }

  setListeners_() {
    this.on(this.$('.vjs-feedback-form-close'), 'click', () => {
      this.hide();
    });

    if (this.$('.vjs-feedback-form-send')) {
      this.on(this.$('.vjs-feedback-form-send'), 'click', () => {
        this.send();
      });
    }
  }

  createClose_() {
    let close = super.createEl('span', {
      className: 'vjs-feedback-form-close'
    });
    dom.insertContent(close, '\u00D7');
    return close;
  }

  createHeading_() {
    let heading = super.createEl('div', {
      className: 'vjs-feedback-form-caption'
    }, {
      'role': 'heading'
    });
    let caption = this.showHelpInstruction() ? 'Report a problem' : this.options_.caption;
    dom.insertContent(heading, this.localize(caption));
    return heading;
  }

  createFields_() {
    let select = super.createEl('select', {
      id: 'vjs_feedback_subject',
      className: 'vjs-feedback-form-select'
    });
    let options = this.options_.issues.map(opt => {
      let o = super.createEl('option', {
        value: this.localize(opt)
      });
      return dom.insertContent(o, this.localize(opt));
    });
    dom.insertContent(select, options);

    let email = super.createEl('input', {
      id: 'vjs_feedback_contact_email',
      className: 'vjs-feedback-form-email',
      placeholder: this.localize('Feedback email'),
    }, {
      type: 'email'
    });

    let message = super.createEl('textarea', {
      id: 'vjs_feedback_feed_text',
      className: 'vjs-feedback-form-textarea',
      placeholder: this.localize('Feedback message')
    });

    let subtext = super.createEl('div', {
      className: 'vjs-feedback-form-subtext'
    });

    subtext.insertAdjacentHTML("afterBegin", this.options_.subText);

    let resp = super.createEl('div', {
      id: 'vjs_feedback_resp',
      className: 'vjs-feedback-form-resp'
    });

    let sendBtn = super.createEl('input', {
      className: 'vjs-feedback-form-send',
      value: this.localize('Feedback send')
    }, {
      type: 'button'
    });

    let fields = super.createEl('div', {
      className: 'vjs-feedback-form-fields'
    });
    dom.insertContent(fields, [select, email, message, subtext, resp, sendBtn]);

    return fields;
  }

  createHelpInstruction_() {
    let content = dom.createEl('div', {
			className: 'vjs-help-instruction-msg'
    });
    let link = dom.createEl('a', {
			className: 'vjs-help-instruction-link'
    });
    link.href = this.options_.helpUrl;
    link.text = this.localize('link');
    dom.appendContent(
      content,
      [this.localize('To resolve viewing issues, follow the link'), link]
    );
    return content;
  }

  show() {
    super.show();
    this.player_.addClass('vjs-feedback-opened');
    this.playerPaused = this.player_.paused();
    if (!this.playerPaused) {
      this.player_.pause();
    }
  }

  hide() {
    super.hide();
    this.clear();
    this.player_.removeClass('vjs-feedback-opened');
    if (!this.playerPaused) {
      this.player_.play();
    }
  }

  send() {
    let data = this.getData();
    utils.xhr(this.options_.url, {method: 'POST', data}, (err, resp, body) => {
      let respEl = this.$('#vjs_feedback_resp');
      let r = body && JSON.parse(body) || '';
      if (r.success || 
        resp.statusCode == '200' && !r.error && !err) {
        respEl.innerHTML = r && r.success || this.localize('Feedback send success');
        this.addClass('vjs-feedback-form_sended');
      } else {
        respEl.innerHTML = r && r.error || this.localize('Feedback send fail');
      }
    });
  }

  clear() {
    if (this.showHelpInstruction()) {
      return;
    }
    this.$('#vjs_feedback_subject').selectedIndex = 0;
    this.$('#vjs_feedback_contact_email').value = '';
    this.$('#vjs_feedback_feed_text').value = '';
    this.$('#vjs_feedback_resp').innerHTML = '';
    this.removeClass('vjs-feedback-form_sended');
  }

  getData() {
    let s = this.options_.formScope,
        d = {}, 
        opts = Object.assign({}, this.options_.util_data, this.options_.data);

    // user input data
    ['contact_email', 'subject', 'feed_text'].forEach((el) => {
      d[s + '[' + el + ']'] = encodeURIComponent(this.$('#vjs_feedback_' + el).value);
    });

    // util & options passed data
    for (let fld in opts) {
      d[s + '[' + fld + ']'] = opts[fld];
    }

    if (this.player_.vast && this.player_.vast.ga.userId) d[s + '[uid]'] = this.player_.vast.ga.userId;

    return d;
  }

  buildCSSClass() {
    return `vjs-feedback-form ${this.showHelpInstruction() ? 'vjs-help-instruction' : ''} ${super.buildCSSClass()}`;
  }

  content() {
    let content = [
      this.createClose_(),
      this.createHeading_(),
    ];
    if (this.showHelpInstruction()) {
      content.push(this.createHelpInstruction_());
    } else {
      content.push(this.createFields_());
    }
    return content;
  }

  createEl() {
    let doc = super.createEl('div', {
      className: 'vjs-feedback-form-doc'
    }, {
      role: 'document'
    });
    dom.appendContent(doc, this.content());

    let el = super.createEl('div', {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      'role': 'dialog'
    });
    dom.insertContent(el, doc);

    return el;
  }
}

Component.registerComponent('FeedbackForm', FeedbackForm);
export default FeedbackForm;